<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center" style="color: #fdcc05">{{
        $t("partyReception")
      }}</VCardTitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(send)">
            <div class="py-2">
              <CustomInputText
                :label="$t('enterAmount')"
                only="number"
                :rules="{
                  required: true,
                  max_value: contractItemCount,
                }"
                v-model="amount"
                class="user_input no-margin"
              ></CustomInputText>
            </div>
            <div class="py-2">
              <CustomInputText
                :label="$t('defectiveGoodsNumber')"
                only="number"
                :rules="{ required: true }"
                v-model="defectedAmount"
                class="user_input no-margin"
              ></CustomInputText>
            </div>
            <div v-if="defectedAmount > 0">
              <div class="py-2">
                <CustomTextTextarea
                  rules="required"
                  :label="$t('leaveComment')"
                  class="user_input"
                  v-model="description"
                ></CustomTextTextarea>
              </div>

              <ValidationProvider
                tag="div"
                class="py-2"
                :name="$t('file')"
                rules="required|document"
                v-slot="{ errors }"
              >
                <VFileInput
                  v-model="files"
                  :error-messages="errors[0]"
                  :label="$t('attachFile') + '*'"
                ></VFileInput>
              </ValidationProvider>
            </div>
            <div class="text-right">
              <VBtn type="submit" color="primary">{{ $t("send") }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      amount: null,
      defectedAmount: 0,
      contractItemCount: null,
      contractItemId: null,
      files: [],
      description: null,
    };
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
    },
  },
  methods: {
    clear() {
      this.amount = null;
      this.defectedAmount = 0;
      this.description = null;
      this.files = null;
      this.$refs.formObs.reset();
    },
    async send() {
      this.showLoading();
      try {
        const formData = new FormData();
        formData.append("accept", this.amount.replace(/,/g, "."));
        formData.append("contractItemId", this.contractItemId);
        formData.append("reject", this.defectedAmount);
        formData.append("description", this.description);
        formData.append("files", this.files);

        await this.$http.post("/contract/partition-accept-item", formData);
        this.$emit("updateTableData");
        this.setSuccess({ text: this.$t("successfullySent") });
        this.close();
      } catch (e) {
        console.log(e);
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open(contractItemId, count, acceptedCount, rejectedCount) {
      this.contractItemId = contractItemId;
      this.contractItemCount =
        +count -
        acceptedCount -
        rejectedCount -
        this.amount -
        this.defectedAmount;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
